import React from 'react';
import AppCTA from './app-cta';
import SampleSearch from './sample-search';
import Button from './button';
import AdvancedSearch from './advanced-search';

import { equality } from '../constants';

import { ToggleBlock, ENTRY } from 'react-toggle-block';

export default class SearchControls extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchParams: {},
            advancedSearchOpen: false
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.searchParams) {
            this.setState({
                searchParams: newProps.searchParams
            });
        }
    }

    get searchParams() {
        return this.state.searchParams || {};
    }

    updateSearchParams(data) {
        this.setState({
            searchParams: Object.assign({}, this.state.searchParams, data)
        });
    }

    mapSampleSearch(params) {
        return {             
            searchText: params.text,
            searchTextCompare: equality.CONTAINS,
            dateFrom: params.dateMin,
            dateTo: params.dateMax,
            pageNumber: 1
        }
    }

    normalizeParams(params) {
        params = Object.assign({}, params);
        params.dateFrom = params.dateFrom ? params.dateFrom.format() : params.dateFrom;
        params.dateTo = params.dateTo ? params.dateTo.format() : params.dateTo;
        return params;
    }

    handleSearch(params = this.searchParams) {        
        params = this.normalizeParams(params);

        if (typeof this.props.onSearch === 'function') {            
            this.props.onSearch(params);
        }
    }

    handleAdvancedSearchToggle(e) {
        if (typeof this.props.onAdvancedSearchToggle === 'function') {
            this.props.onAdvancedSearchToggle(e);
        }

        this.setState({
            advancedSearchOpen: !this.state.advancedSearchOpen
        });
    }

    handleExport() {
        if (typeof this.props.onExport === 'function') {
            this.props.onExport(this.normalizeParams(this.searchParams))
        }
    }

    clear() {
        this.setState({
            searchParams: {}
        }, () => {            
            this.handleSearch()
        });        
    }

    render() {
        const searchableFields = this.props.searchableFields || [];
        const action = this.state.advancedSearchOpen ? 'Hide' : 'Show';

        return (
            <div className={['component-search-controls', this.props.className].join(' ')}>
                <AppCTA className="submit-cta col-sm-6 col-md-4 col-lg-4" style={AppCTA.styles.MINI_SUBMIT} />
                <div className="col-sm-6 col-md-8 col-lg-8">
                    <SampleSearch
                        searchParams={this.searchParams}
                        className="grid-search-bar"
                        onChange={search => this.updateSearchParams(this.mapSampleSearch(search))}
                        onSearch={() => this.handleSearch()}
                        searchValues={{
                            text: this.searchParams.searchText || '',
                            dateMin: this.searchParams.dateFrom,
                            dateMax: this.searchParams.dateTo
                        }} />
                    <Button className="clear-button" onClick={() => this.clear()}>Clear Results</Button>
                </div>
                <div className="col-sm-12 controls-wrapper">
                    <div className="controls">
                        <Button className={['advanced-button', 'action-' + action].join(' ')} onClick={(e) => this.handleAdvancedSearchToggle(e)}>
                            <span className="advanced-button-text">{action} Advanced Search</span>
                        </Button>
                        <Button hide={!this.props.onExport} busy={this.props.exportBusy} onClick={e => this.handleExport(e)} className="export-all">Export All Current Results</Button>
                    </div>
                    <ToggleBlock visible={this.state.advancedSearchOpen} entry={ENTRY.FROM_TOP}>
                        <AdvancedSearch 
                            fields={searchableFields}
                            values={this.searchParams}
                            onChange={(e, data) => this.updateSearchParams(data)}
                            onSearch={() => this.handleSearch()} />                            
                    </ToggleBlock>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./web-app/components/search-controls.jsx